import { createAction, props } from '@ngrx/store';
import { Signature } from '../../interfaces/signature';

export const loadSignatures = createAction('[Signature/API] Load Signatures');

export const loadSignaturesSuccess = createAction(
  '[Signature/API] Load Signatures Success',
  props<{ signatures: Signature[] }>()
);

export const loadSignaturesFailure = createAction('[Signature/API] Load Signatures Failure', props<{ error: any }>());

export const createSignature = createAction(
  '[Signature/API] Create Signature',
  props<{ signature: Exclude<Signature, 'id'> }>()
);

export const createSignatureSuccess = createAction(
  '[Signature/API] Create Signature Success',
  props<{ signature: Signature }>()
);

export const createSignatureFailure = createAction('[Signature/API] Create Signature Failure', props<{ error: any }>());

export const updateSignature = createAction('[Signature/API] Update Signature', props<{ signature: Signature }>());

export const updateSignatureSuccess = createAction(
  '[Signature/API] Update Signature Success',
  props<{ signature: Signature }>()
);

export const updateSignatureFailure = createAction('[Signature/API] Update Signature Failure', props<{ error: any }>());

export const deleteSignature = createAction('[Signature/API] Delete Signature', props<{ signature: Signature }>());

export const deleteSignatureSuccess = createAction('[Signature/API] Delete Signature Success', props<{ id: number }>());

export const deleteSignatureFailure = createAction('[Signature/API] Delete Signature Failure', props<{ error: any }>());

export const clearSignatures = createAction('[Signature/API] Clear Signatures');
